import { RouteObject } from "react-router";
import { CatalogListRoute } from "./catalog-list-route";
import { CatalogRoute } from "./[catalogId]/catalog-route";

export const textblocksBaseDataRoutes: RouteObject[] = [
  {
    index: true,
    element: <CatalogListRoute />,
  },
  {
    path: ":catalogId",
    element: <CatalogRoute />,
  },
];
